import { render } from "./EmergencyAnswerImageModal.vue?vue&type=template&id=52a482d0&scoped=true&ts=true"
import script from "./EmergencyAnswerImageModal.ts?vue&type=script&lang=ts"
export * from "./EmergencyAnswerImageModal.ts?vue&type=script&lang=ts"

import "./EmergencyAnswerImageModal.scss?vue&type=style&index=0&id=52a482d0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a482d0"]])

export default __exports__